import { createActions, ngrxEvent } from '@core/ngrx-legacy';

const actions = createActions('TellentAssistantEngagements', {
  record: ngrxEvent<{ id: string }>(),
  recordSuccess: ngrxEvent<{ id: string }>(),
  recordFailed: ngrxEvent<{ id: string }>(),
});

export { actions as TellentAssistantEngagementsActions };
